import { axios } from '@vyce/core/src/api';

import { StatusMessage } from '../types';
import config from '../config';

const URL = `${config.gatewayApiUrl}`;

export const triggerCompanySyncRequest = ({
  companyId,
  resourceId,
}: {
  companyId: string;
  resourceId: string;
}) => {
  return axios.post<StatusMessage>(`${URL}/service/v1/trigger/mirroring/sync-company/${companyId}`, {
    resource_id: resourceId,
    batch_size: 30,
    unsynced_only: false,
  });
};
